/* tslint:disable */
/* eslint-disable */
/**
 * Backoffice Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    GetCardRequest,
    GetCardRequestFromJSON,
    GetCardRequestToJSON,
    GetCardResponse,
    GetCardResponseFromJSON,
    GetCardResponseToJSON,
    ListCardsRequest,
    ListCardsRequestFromJSON,
    ListCardsRequestToJSON,
    ListCardsResponse,
    ListCardsResponseFromJSON,
    ListCardsResponseToJSON,
} from '../models';

export interface PostGetCardRequest {
    getCardRequest?: GetCardRequest;
}

export interface PostListCardRequest {
    listCardsRequest?: ListCardsRequest;
}

/**
 * 
 */
export class CardsApi extends runtime.BaseAPI {

    /**
     */
    async postGetCardRaw(requestParameters: PostGetCardRequest): Promise<runtime.ApiResponse<GetCardResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // CognitoAuthorizer authentication
        }

        const response = await this.request({
            path: `/cards/get`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetCardRequestToJSON(requestParameters.getCardRequest),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => GetCardResponseFromJSON(jsonValue));
    }

    /**
     */
    async postGetCard(requestParameters: PostGetCardRequest): Promise<GetCardResponse> {
        const response = await this.postGetCardRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async postListCardRaw(requestParameters: PostListCardRequest): Promise<runtime.ApiResponse<ListCardsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // CognitoAuthorizer authentication
        }

        const response = await this.request({
            path: `/cards/list`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ListCardsRequestToJSON(requestParameters.listCardsRequest),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ListCardsResponseFromJSON(jsonValue));
    }

    /**
     */
    async postListCard(requestParameters: PostListCardRequest): Promise<ListCardsResponse> {
        const response = await this.postListCardRaw(requestParameters);
        return await response.value();
    }

}
